$(document).ready(function () {
  // Only proceed if .e-elemental-area div exists
  if ($(".e-elemental-area").length) {
    var accordions = $(".e-elemental-area .accordionsectionheaderelement");

    // Function to open a specific accordion
    function openAccordion(accordion) {
      accordion.nextUntil(".accordionsectionheaderelement").show();
      accordion.find(".e-accordion-section-header__arrow").addClass("e-accordion-section-header__arrow--open");
    }

    // Function to close all accordions
    function closeAllAccordions() {
      accordions.each(function () {
        $(this).nextUntil(".accordionsectionheaderelement").hide();
        $(this).find(".e-accordion-section-header__arrow").removeClass("e-accordion-section-header__arrow--open");
      });
    }

    // Toggle accordion on click
    accordions.click(function () {
      var isOpen = $(this).find(".e-accordion-section-header__arrow").hasClass("e-accordion-section-header__arrow--open");

      // Close all other accordions
      accordions.not(this).nextUntil(".accordionsectionheaderelement").slideUp();
      accordions.not(this).find(".e-accordion-section-header__arrow").removeClass("e-accordion-section-header__arrow--open");

      // Toggle the clicked accordion based on its current state
      if (!isOpen) {
        $(this).find(".e-accordion-section-header__arrow").addClass("e-accordion-section-header__arrow--open");
        $(this).nextUntil(".accordionsectionheaderelement").slideDown();
      } else {
        $(this).find(".e-accordion-section-header__arrow").removeClass("e-accordion-section-header__arrow--open");
        $(this).nextUntil(".accordionsectionheaderelement").slideUp();
      }
    });

    // Scan for validation error or success message and open the accordion containing it, then ensure it's in view
    setTimeout(function () {
      var validationMessage = $(".e-elemental-area span.message.validation");
      var successMessage = $("#uff"); // Select the div with id #uff

      // Function to open an accordion containing a specific element
      function openContainingAccordion(element) {
        var formElement = element.closest(".dnadesign__elementaluserforms__model__elementform");
        var accordion = formElement.prevUntil(".accordionsectionheaderelement").prev();

        if (formElement.length && accordion.length) {
           openAccordion(accordion);
          return true;
        } else {
          console.error("Accordion not found");
          return false;
        }
      }

      closeAllAccordions();

      if (validationMessage.length) {
        if (openContainingAccordion(validationMessage)) {
          scrollToElement(validationMessage);
        }
      } else if (successMessage.length) {
        if (openContainingAccordion(successMessage)) {
          scrollToElement(successMessage);
        }
      } else {
        console.log("ash.js", "No validation error or success message found");
        openAccordion(accordions.first());
      }
    }, 250); // Delay time in milliseconds
  }
});
